import React from 'react';
import { Nav } from 'react-bootstrap';
import './Sidebar.scss'
import { FaHome, FaRegComment, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import "@maersk-global/mds-react-wrapper/styles/core.css";

interface SidebarProps {
  isSidebarExpanded: boolean;
  toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isSidebarExpanded, toggleSidebar }) => {
  return (
    <div className={`sidebar ${isSidebarExpanded ? 'expanded' : 'compressed'}`} role='complementary'   data-sidebar-state={isSidebarExpanded ? 'expanded' : 'compressed'}>
      <div className='sidebar-toggle' onClick={toggleSidebar} data-testid='toggle-icon'>
        {isSidebarExpanded ? <FaAngleDoubleLeft /> : <FaAngleDoubleRight />}
      </div>
      <div className='sidebar-logo-container'>
          <img src='logo192.png' alt='logo' className='sidebar-logo'></img>
      </div>
      <ul>
        <li>
          <Nav.Link href='#home' className='sidebar-link-vertical'>
            <FaHome size={20} />
            <span className='sidebar-text-home'>Home</span>
          </Nav.Link>
        </li>
      </ul>
      <div className='sidebar-footer'>
        <Nav.Link href='#Feedback'>
          <div className='feedback-icon sidebar-link-vertical'>
            <FaRegComment size={20} />
            <span className='sidebar-text'>Feedback</span>
          </div>
        </Nav.Link>
      </div>
    </div>
  );
};

export default Sidebar;
